import selectSubmit from './selectSubmit';

const els = document.querySelectorAll('.js-select-submit');

for (let el of els) {
    selectSubmit(el);
}
